import MUIBlockIcon from "@mui/icons-material/Block";
import MUICrossIcon from "@mui/icons-material/Close";

import { black } from "~/common/theming/colors";

export const CrossIcon = () => <MUICrossIcon sx={{ stroke: black }} />;

export const BlockIcon = () => <MUIBlockIcon sx={{ stroke: black }} />;
